import React from "react"
import NumericTypeSwitch from "./NumericTypeSwitch"
import SgOnlinesInput from "./SgOnlinesInput"
import TempCityNameSelect from "./TempCityNameSelect"

const VariablesInputs = ({ selectedTextObj, updateSelectedText }) => {
    return (
        <>
            <NumericTypeSwitch
                selectedTextObj={selectedTextObj}
                updateSelectedText={updateSelectedText}
            />
            <SgOnlinesInput
                selectedTextObj={selectedTextObj}
                updateSelectedText={updateSelectedText}
            />
            <TempCityNameSelect
                selectedTextObj={selectedTextObj}
                updateSelectedText={updateSelectedText}
            />
        </>
    )
}

export default VariablesInputs
